import React from 'react';
import clsx from 'clsx';
import styles from './FormInstruction.module.scss';

/**
 * FormInstruction
 *
 * Presentational component for form-level instructional text.
 * Intended to appear near the top of a Form.
 *
 * Responsibilities:
 * - Provide consistent typography and spacing
 * - Participate in Form vertical rhythm
 *
 * Props:
 * - children: React nodes (required)
 * - className: string (optional)
 */
const FormInstruction = ({ children, className }) => {
  return (
    <div className={clsx(styles.instruction, className)}>
      {children}
    </div>
  );
};

export default FormInstruction;
